// Re-export role constants and utilities
export * from './roles';

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:9999/api';

export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
} as const;

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_DATA: 'user_data',
  THEME: 'theme',
} as const;

export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const BUTTON_TEXTS = {
  APPROVE_SCORE: 'Approve Score',
  APPROVING: 'Approving...',
  PUBLISH: 'Publish',
  PUBLISHING: 'Publishing...',
  RELEASE_TO_HOTEL: 'Release To Hotel',
  RELEASING: 'Releasing...',
  CALCULATE_ALO_SCORE: 'Calculate Alō Score',
  CALCULATING: 'Calculating...',
  SAVE_REVIEW: 'Save Review',
  SAVING: 'Saving...',
  SUBMIT_QUESTIONNAIRE: 'Submit Questionnaire',
  SUBMITTING: 'Submitting...',
  RESUBMIT_QUESTIONNAIRE: 'Resubmit Questionnaire',
  RESUBMITTING: 'Resubmitting...',
  REOPEN_SUBMISSION: 'Reopen Submission',
  REOPENING: 'Reopening...',
} as const;
